const d = () => {
}, g = (t) => t, h = /"((\w+:(\/?\/?))?[^\s,]+)"/;
function p(t) {
  const e = t.toString().match(h);
  return e ? e.filter(g)[1] : null;
}
const f = {
  /** This only works in Chromium browsers, as other engines (like Firefox) do not carry the module url in the error message */
  PARSE_ERROR_MESSAGE: (t, n) => {
    const e = t.message.replace("Failed to fetch dynamically imported module: ", "").trim();
    return new URL(e).href;
  },
  /** Should work in most browsers */
  PARSE_IMPORTER_FUNCTION_BODY: (t, n) => p(n)
}, R = {
  strategy: "PARSE_IMPORTER_FUNCTION_BODY",
  importFunction: (t) => import(
    /* @vite-ignore */
    t
  ),
  logger: d
};
function w(t, n = {}) {
  const e = {
    ...R,
    ...n
  }, { logger: r, importFunction: l, strategy: s } = e;
  return async (u) => {
    try {
      return await u();
    } catch (o) {
      r(Date.now(), "Importing failed: ", o);
      const a = f[s](o, u);
      if (r(`Parsed url using ${s}:${a}`), !a)
        throw r("Unable to determine path to module when trying to reload"), o;
      for (let i = 0; i < t; i++) {
        let c = `${a}?t=${+/* @__PURE__ */ new Date()}`;
        r(
          Date.now(),
          `Trying re-import module using cache busted path: ${c}`
        );
        try {
          return await l(c);
        } catch {
          r(`Import for ${c} failed`), await new Promise(
            (m) => setTimeout(m, 1e3 * 2 ** (i - 1))
          );
        }
      }
      throw o;
    }
  };
}
export {
  w as c
};
